/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import _ from 'lodash'

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetUsersOTDSData(otdsUserID, isExternal) {
  const response = await $.soap({
    body: {
      GetUsersOTDSData: {
        $xmlns: 'http://dla.mil/ems/bpm/user',
        OTDSUserID: otdsUserID
      }
    },
    blueprintArrays: ['GetUsersOTDSDataResponse.Groups.GroupName'],
    blueprint: {
      groups: [
        'GetUsersOTDSDataResponse.Groups.GroupName'
      ],
      edipi: '$..EDIPI'
    }
  });

  cleanUpResponse(response);

  const roles = response.groups[0];
  const userRoles = isExternal === '1' ? ['EMS_EXT_CAC', 'EMS_EXT_EMAIL'] : ['EMS All Users']
  const checkedRoles = [];

  _.each(userRoles, (role) => { if (_.includes(roles, role)) checkedRoles.push(role) });
  const res = {checkedRoles, edipi: response.edipi}
  return res;
}
